<template>
    <div class="position-relative news-browser-wrap">
        <div
            v-if="meta && meta.current_page > 1"
            class="news-browser-arrow arrow-prev"
        >
            <a
                href="#"
                @click.prevent="loadPrevious"
            >
                <svg class="icon icon-triangle-prev"><use xlink:href="#triangle-prev" /></svg>
            </a>
        </div>

        <div class="row">
            <div
                v-for="newsItem in items"
                :key="newsItem.id"
                :class="type === 'issuu' ? 'col-12 pb-5' : 'col-12 col-sm-6 col-md-4 col-lg-3 pb-5'"
            >
                <news-item
                    :news-item="newsItem"
                    :category-route="categoryRoute"
                />
            </div>
        </div>

        <div
            v-if="meta && meta.current_page < meta.last_page"
            class="news-browser-arrow arrow-next"
        >
            <a
                href="#"
                @click.prevent="loadNext"
            >
                <svg class="icon icon-triangle-next"><use xlink:href="#triangle-next" /></svg>
            </a>
        </div>

        <pagination
            v-if="meta !== null"
            :data="paginator"
            :limit="2"
            :show-disabled="true"
            @pagination-change-page="loadPage"
        >
            <span slot="prev-nav" />
            <span slot="next-nav" />
        </pagination>
    </div>
</template>

<script>
import NewsItem from './NewsItem.vue'

/*eslint-disable no-undef*/
export default {
    name: 'BrowseByType',

    components: {
        NewsItem
    },

    props: {
        type: {
            type: String,
            required: true
        },
        subtype: {
            type: String,
            default: null
        },
        category: {
            type: Number,
            default: null
        },
        categoryRoute: {
            type: String,
            required: true
        },
        locale: {
            type: String,
            required: true
        },
        newsEndpoint: {
            type: String,
            required: true
        },
    },

    data() {
        return {
            items: [],
            meta: null,
            links: null
        }
    },

    computed: {
        paginator() {
            return {
                data: this.items,
                meta: this.meta,
                links: this.links
            }
        }
    },

    watch: {
        type() {
            this.items = []
            this.meta = null
            this.links = null

            this.loadInitial()
        }
    },

    created() {
        if (this.meta === null) {
            this.loadInitial()
        }
    },

    methods: {
        async loadInitial() {
            await this.loadItems(1)

            this.$emit('meta-loaded', this.meta)
        },

        loadPrevious() {
            this.loadItems(this.meta.current_page - 1)
        },

        loadNext() {
            this.loadItems(this.meta.current_page + 1)
        },

        loadPage(page) {
            this.loadItems(page)
        },

        async loadItems(page) {
            const response = await axios.post(this.newsEndpoint, {
                page: page,
                type: this.type,
                category: this.category,
                subtype: this.subtype
            })

            this.items = response.data.data
            this.meta = response.data.meta
            this.links = response.data.links
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./resources/sass/_variables.scss";

.pagination {
    margin-bottom: 3rem;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0;
    justify-content: center;
}

::v-deep .page-item.pagination-prev-nav {
    display: none;
}

::v-deep .page-item.pagination-next-nav {
    display: none;
}

::v-deep .page-item.pagination-page-nav {
    margin: 3px;

    &.active {
        &>.page-link {
            padding: 2px 0 0 0;
            font-weight: bold;
            background-color: $zh-suplementary-selected;
            border-color: $zh-suplementary-selected;
        }
    }

    &>.page-link {
        color: $zh-blue;
        display: flex !important;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        padding: 0;
        font-size: 14px;
        border-radius: 12.5px;
        border: 1px solid transparent;
    }
}

.icon-triangle-next, .icon-triangle-prev {
    width: 18px;
    height: 25px;
}
</style>

<style>
.grid-wrap-pages {
    width: 108%;
    display: grid;
    margin-left: -4%;
    grid-template-columns: 4% 1fr 4%;
}
</style>
